module.exports = __webpack_public_path__ + "2096e77c1859dc1a49548d4b0a536fe5.pdf";